import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { TypeCargoUser } from '@/lib/enums'
import { formatNome } from '@/utils/format'

interface CargoFilterProps {
  value: string
  onChange: (value: string) => void
}

export function CargoFilter({ value, onChange }: CargoFilterProps) {
  return (
    <Select onValueChange={onChange} value={value}>
      <SelectTrigger className="w-full md:w-[200px] border-[var(-border-color)] bg-input">
        <SelectValue placeholder="Filtrar por cargo" className="text-primary-foreground" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="Todos">Todos</SelectItem>
        {Object.values(TypeCargoUser).map((cargo, index) => (
          <SelectItem key={index} value={cargo}>
            {formatNome(cargo)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
